import React, { useState } from 'react';
import { NButton } from '@innersource-nn/novoui-react';
import clsx from 'clsx';
import { useAlert } from 'components/message/AlertContext';
import { Credential } from 'types/Credentials';

interface CredentialsContainerProps {
    title: string;
    exportCredentials?: boolean;
    value: string;
    credentials: Credential[];
}

const CredentialsContainer: React.FC<CredentialsContainerProps> = ({
    title,
    exportCredentials,
    value,
    credentials,
}) => {
    const { openAlert } = useAlert();
    const [showBackdrop, setShowBackdrop] = useState(false);

    const copyOnClick = async () => {
        await navigator.clipboard.writeText(value);
        openAlert({
            message: `Section copied to clipboard`,
            title: 'Success',
            severity: 'success',
        });
    };

    return (
        <div>
            <p className="mt-16 mb-8">{title}</p>
            <div
                className={clsx(
                    showBackdrop ? 'border-sea-blue-600' : 'border-true-blue',
                    'relative cursor-pointer p-16 border border-dashed  rounded-lg font-light',
                )}
                onMouseEnter={() => setShowBackdrop(true)}
                onMouseLeave={() => setShowBackdrop(false)}
                onClick={() => copyOnClick()}
            >
                {credentials.map((credential, index) => {
                    return exportCredentials ? (
                        <div key={index} className="flex truncate py-4">
                            <p className="text-forest-green-600">export</p>
                            &nbsp;
                            {credential.key.toUpperCase()}
                            <p className="text-granite-grey-900">
                                ="{credential.value}"
                            </p>
                        </div>
                    ) : credential.simpleValue ? (
                        <p className="text-granite-grey-900">
                            {credential.value}
                        </p>
                    ) : (
                        <div key={index} className="flex truncate py-4">
                            {credential.key}
                            <p className="text-granite-grey-900">
                                &nbsp;= {credential.value}
                            </p>
                        </div>
                    );
                })}
                {showBackdrop && (
                    <div className="absolute inset-0 bg-sea-blue-100 opacity-50 rounded-md" />
                )}
                {showBackdrop && (
                    <div className="absolute inset-0 flex justify-center items-center">
                        <NButton
                            className="bg-sea-blue-600 font-light"
                            square
                            leftIcon="copy"
                        >
                            Copy section
                        </NButton>
                    </div>
                )}
            </div>
        </div>
    );
};
export default CredentialsContainer;
